<template>
    <span :style="fontStyle" :class="fontClass">
        <slot></slot>
    </span>
</template>

<script>
    import WTypographyMixin from '../../mixins/w-typography-mixin'

    /**
     * Spans data using <span> but applies Veutify classes and colours.
     */
    export default {
        name: 'WSpan',
        mixins: [WTypographyMixin],
        props: {
            /**
             * @TODO remove this in future upgrade needed for backwards comp
             * Class to apply to the <span> element.
             */
            spanClass: {
                type: [String, Object],
                default: ''
            }
        },
        computed: {
            fontClass () {
                const vm = this
                return {
                    //@TODO refactor this in future upgrade needed for backwards comp
                    [vm.spanClass ? vm.spanClass : vm.fontSize]: true,
                    [`font-weight-${vm.fontWeight}`]: true,
                    [`text-${vm.transform}`]: true,
                    'font-italic': vm.italic
                }
            }
        }
    }
</script>
